import React, { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { spacing, breakpoints, fontStyle, themeLight } from '../../../theme/index';
import { Close } from '@styled-icons/material/Close';
import { Text, TextVariant } from '../../../text/index';
export const DialogIE = React.memo(({ isOpen = false, size = 'default', children, button, handleClose, title, closeIcon = true, className, }) => {
    const close = useCallback((e) => {
        if (e.key === 'Escape') {
            handleClose();
        }
    }, [handleClose]);
    useEffect(() => {
        window.addEventListener('keydown', close);
        return () => window.removeEventListener('keydown', close);
    }, [close]);
    return (<>
        {isOpen && (<>
            <Overlay onClick={() => handleClose()}/>
            <Container className={className} size={size}>
              <Header>
                {closeIcon && (<button onClick={() => handleClose()} aria-label="Lukk dialogboks">
                    <Close size={24}/>
                  </button>)}
              </Header>
              <Inner>
                {title && <Text variant={TextVariant.Header3}>{title}</Text>}
                {children}
              </Inner>
              {button && <Footer>{button}</Footer>}
            </Container>
          </>)}
      </>);
});
export default DialogIE;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 46, 42, 0.5);
  z-index: 99;
`;
const Container = styled.div `
    display: flex;
    flex-wrap: wrap;
    background-color: ${({ theme }) => theme.background
    ? theme.background.default
    : themeLight.background.default};
    position: fixed;
    top: 50%;
    left: 50%;
    overflow-y: auto;
    z-index: 999;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
    transform: translate(-50%,-50%);
    ${fontStyle.article.articleText};

    /* Default */
    ${({ size }) => size === 'default' &&
    css `
        max-width: 560px;
        max-height: 72%;
      `}

    /* Small */
    ${({ size }) => size === 'small' &&
    css `
        max-width: 420px;
        max-height: 48%;
      `}

    @media (max-width: ${breakpoints.s}) {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        top: auto;
        max-height: 100%;
        transform: none;
        ${fontStyle.bodyText.bodyText};
    };
`;
const Header = styled.div `
  flex-basis: 100%;
  height: ${spacing.space48};
  display: flex;
  justify-content: flex-end;

  button {
    margin-right: ${spacing.space16};
    margin-top: ${spacing.space16};
    padding: 0;
    border: none;
    background-color: inherit;
    touch-action: manipulation;

    @media (max-width: ${breakpoints.s}) {
      margin-right: ${spacing.space12};
      margin-top: ${spacing.space20};
    }

    &:hover {
      cursor: pointer;
    };
  }
`;
const Inner = styled.div `
  margin: 0 ${spacing.space48} ${spacing.space32};
  display: flex;
  flex-direction: column;
  width: 100%;

  h3 {
    margin: 0 0 ${spacing.space16};
  }

  @media (max-width: ${breakpoints.s}) {
    margin: 0 ${spacing.space24} ${spacing.space32};
  }
`;
const Footer = styled.div `
  flex-basis: 100%;
  margin: 0 ${spacing.space48} ${spacing.space48};

  button {
    margin-right: ${spacing.space16};
  }

  @media (max-width: ${breakpoints.s}) {
    margin: 0 ${spacing.space24} ${spacing.space40};
  }
`;
